import { useLayoutEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';

const useBrowserPrompt = ({ when, onBlock }) => {
  const history = useHistory();
  const unblockRef = useRef();

  useLayoutEffect(() => {
    unblockRef.current = history.block(location => {
      if (when) {
        onBlock(location);
        return false;
      }

      // Allow the navigation to go through.
      return true;
    });

    return () => {
      unblockRef.current?.();
    };
  }, [when, onBlock, history]);

  return [unblockRef];
};

export default useBrowserPrompt;
